<style lang="scss">
.exp-bg {
  height: 246px;
  padding: 15px 20px;
  background: url("../assets/images/exp-bg.png");
  background-size: cover;
}

.exp-spent {
  font-size: 28px;
  font-weight: bold;
  color: #F8E71C;
  padding-left: 8px;
  letter-spacing: 2px;
}

.exp-status {
  font-size: 18px;
  font-weight: bold;
  color: #8FD918;
  flex: 1;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.exp-status-dot {
  width: 8px;
  height: 8px;
  background: #8FD918;
  border-radius: 4px;
  margin-right: 5px;
  display: block;
}

.exp-title {
  font-size: 18px;
  font-weight: bold;
  color: #FFFFFF;
}

.exp-title-line {
  display: flex;
  align-items: center;
  //justify-content: center;
}

.exp-spent-line {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
}

.exp-info-line {
  font-size: 12px;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: 8px;
  display: flex;
  align-items: center;
}

.exp-info-right {
  flex: 1;
  text-align: right;
}

.exp-infos {
  margin-top: 26px;
}

.finish-btn {
  width: 265px;
  height: 36px;
  background: #FF4158;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: bold;
  color: #FFFFFF;
  border: 0;
  margin-top: 10px;
}

.exp-wrapper {
  //position: absolute;
  //left: 0;
  //top: 46px;
  margin-left: -20px;
  margin-right: -20px;
  padding: 20px;
  background: #fff;
}

.exp-line-title {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
}

.exp-line-status {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
}

.exp-line-status-circle {
  width: 6px;
  height: 6px;
  background: #999999;
  border-radius: 3px;
  margin-right: 4px;
}

.exp-line-status-running {
  color: #8FD918;
  font-weight: bold;
}

.exp-line-status-running .exp-line-status-circle {
  background: #8FD918;
}

.applier {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  margin-bottom: 15px;
}

.do-score {
  font-size: 14px;
  color: #4A89DC;
}

.view-score {
  font-size: 14px;
  color: #999999;
}

.release-time {
  font-size: 14px;
  color: #4A89DC;
}

.release-tip {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.exp-timeout {
  font-size: 14px;
  color: #FFA500;
}

.released-tag {
  font-size: 12px;
  color: #8FD918;
  margin-left: 8px;
}

.confirm-finish {
  width: 80%;
  left: 10%;
  background: #fff;
}

.finish-panel {
  .panel-title {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 0 15px;
  }

  .panel-content {
    padding: 15px;
  }
}

</style>
<style lang="scss" scoped>
.app-header {
  height: 46px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  //border-bottom: solid 1px rgba(0, 0, 0, 0.03);
  //box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.08);
  z-index: 2;

  font-size: 16px;
  color: #000;
  font-weight: bold;
}

.header-left, .header-right {
  height: 100%;
  width: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;

}

.header-left {
  left: 0;
}

.header-right {
  right: 0;
}

.icon-left {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
}

.go-home {
  display: block;
  width: 21px;
  height: 19px;
  background: url("../assets/images/go-home.png");
  background-size: contain;
}

</style>
<template>
  <div>
<!--    <AppHeader title="实验列表"/>-->
    <div class="app-header" >
      实验列表
      <div class="header-left" @click="goHome()"><i class="iconfont icon-prev"></i></div>
      <div class="header-right" @click="goHome()"><i class="go-home"></i></div>
    </div>
    <div class="exp-wrapper" v-if="this.curExp">
      <div class="exp-bg">
        <div class="exp-title-line">
          <div class="exp-title">{{ curExp.equipmentId }}</div>
          <div class="exp-status"><span class="exp-status-dot"></span>实验中</div>
        </div>
        <div class="exp-spent-line">已实验<span class="exp-spent">{{ curExp.spent }}</span></div>

        <div class="exp-infos">
          <div class="exp-info-line">
            <div class="exp-info-left">实验人：{{ curExp.userName }}</div>
            <div class="exp-info-right">实验地点：{{ curExp.eqLocation }}</div>
          </div>
          <div class="exp-info-line">
            上机时间：{{ formatDate(curExp.beginAt) }}
          </div>
          <div class="exp-info-line" v-if="curExp.bookingType === 'BOOKING' && curExp.booking">
            预约时间：{{ beginEnd(curExp.booking.beginAt, curExp.booking.endAt) }}
          </div>
        </div>
        <div class="flex-center">
          <button class="finish-btn" :disabled="loadFlag" @click="endExp(curExp.id)">结束实验</button>
        </div>
      </div>
    </div>

    <div slot="content" v-infinite-scroll="loadExps"
         :infinite-scroll-disabled="loading || noMore"
         :infinite-scroll-distance="10">
      <div class="line" v-for="exp of exps" :key="exp.id">
        <div class="flex-dir-row exp-line-title">
          {{ exp.equipmentId }}
          <div class="flex-item-auto exp-line-status" :class="{'exp-line-status-running': exp.endAt==null}">
            <div class="exp-line-status-circle"></div>
            <div v-if="exp.endAt!=null">已结束</div>
            <div v-else>实验中</div>
          </div>
        </div>
        <div class="applier">申请人：{{ exp.userName }}</div>
        <div>实验起止时间: {{ beginEnd(exp.beginAt, exp.endAt) }}</div>
        <div class="flex-dir-row">
          实验时长: {{ displaySpent(exp.spent) }}<span class="released-tag" v-if="exp.bookingType === 'BOOKING' && exp.releaseDuration>0">已释放</span>
          <div class="flex-item-auto text-right">
            <!-- 以下释放机时和实验超时只在预约上机模式(BOOKING)下显示 -->
            <!-- 实验中且当前时间早于预约结束时间：显示释放机时按钮 -->
            <div class="release-time" @click="releaseTime(exp)" v-if="exp.bookingType === 'BOOKING' && exp.endAt==null && canExpReleaseTime(exp)">释放机时</div>
            <!-- 实验中但已超过预约结束时间：显示实验超时 -->
            <div class="exp-timeout" v-else-if="exp.bookingType === 'BOOKING' && exp.endAt==null && !canExpReleaseTime(exp)">实验超时</div>
            <!-- 已结束且未释放且当前时间早于预约结束时间：显示释放机时按钮 -->
            <div class="release-time" @click="releaseTimeAfterEnd(exp)" v-else-if="exp.bookingType === 'BOOKING' && exp.endAt!=null && !exp.releaseDuration && canExpReleaseTime(exp)">释放机时</div>
            <!-- 已结束：显示评价按钮 -->
            <div class="view-score" @click="viewScore(exp)" v-else-if="exp.endAt!=null && exp.score>0">已评价</div>
            <div class="do-score" @click="doScore(exp)" v-else-if="exp.endAt!=null">评价</div>
          </div>
        </div>
      </div>
      <div class="line text-center" v-if="exps.length===0">暂无记录</div>
    </div>

    <mt-popup
        v-model="popupVisible"
        position="right"
        class="confirm-finish"
        v-if="curExp!=null"
    >
      <Panel class="finish-panel">
        <div slot="title">
          结束实验
        </div>
        <div slot="content">
          <div>确定要结束当前实验？</div>
          <!-- 释放机时选项只在预约上机模式(BOOKING)下显示 -->
          <div v-if="curExp.bookingType === 'BOOKING' && canReleaseTime" style="margin-top: 10px;">
            <div class="release-tip">您当前实验的预约机时还剩{{ remainTimeMinutes }}分钟，预计可释放机时为{{ releaseTimeMinutes }}分钟。请确认是否释放未使用的预约机时？</div>
            <mt-switch style="margin-top: 10px" v-model="finalAccounts">
              释放机时
            </mt-switch>
          </div>
          <!-- 预约上机模式下实验超时提示 -->
          <div v-else-if="curExp.bookingType === 'BOOKING' && !canReleaseTime" style="margin-top: 10px;">
            <div class="exp-timeout">实验已超时，无未使用机时可释放！</div>
          </div>
          <div class="grid gap10" style="margin: 20px -10px -10px;">
            <div class="grid-cell-1-2">
              <div class="btn btn-small green" v-if="curExp.blueToothId" @click="doEndTwo(curExp.id)">蓝牙确定结束</div>
              <div class="btn btn-small green" v-else @click="doEnd(curExp.id)">确定结束</div>
            </div>
            <div class="grid-cell-1-2">
              <div class="btn btn-small normal" @click="cancelEnd()">取消</div>
            </div>
          </div>
        </div>
      </Panel>
    </mt-popup>
  </div>
</template>

<script>
// AppHeader 和 InfiniteScroll 已在模板中通过指令使用，无需注册为组件
import {Toast, MessageBox} from 'mint-ui';
import Panel from "@/components/Panel";
import wx from "weixin-js-sdk";

let intervalId
export default {
  components: {
    Panel
  },
  data() {
    return {
      page: 1,
      exps: [],
      loading: false,
      noMore: false,
      curExp: null,
      popupVisible: false,
      finalAccounts: false,
      isNff: false,
      blueToothTypeShow:false,
      endFlag: false,
      loadFlag: false
    }
  },
  computed: {
    // 是否可以释放机时：当前时间早于预约结束时间
    canReleaseTime() {
      if (!this.curExp || !this.curExp.booking || !this.curExp.booking.endAt) {
        return false
      }
      const now = this.$moment().valueOf()
      const endAt = this.curExp.booking.endAt
      return now < endAt
    },
    // 剩余时间（分钟）
    remainTimeMinutes() {
      if (!this.curExp || !this.curExp.booking || !this.curExp.booking.endAt || !this.curExp.booking.beginAt) {
        return 0
      }
      const now = this.$moment().valueOf()
      const beginAt = this.curExp.booking.beginAt
      const endAt = this.curExp.booking.endAt
      let remainMs
      // 若当前时间早于预约开始时间，remainTime = endAt - beginAt
      // 若当前时间晚于等于预约开始时间，remainTime = endAt - currentTime
      if (now < beginAt) {
        remainMs = endAt - beginAt
      } else {
        remainMs = endAt - now
      }
      return Math.max(0, Math.floor(remainMs / (1000 * 60)))
    },
    // 可释放时间（分钟）= 剩余步长数 * 预约步长
    releaseTimeMinutes() {
      if (!this.curExp || !this.curExp.booking) {
        return 0
      }
      // 预约步长，默认30分钟
      const step = this.curExp.bookingStep || 30
      // 剩余步长数 = (remainTime/预约步长)向下取整
      const stepCount = Math.floor(this.remainTimeMinutes / step)
      // 可释放时间 = 剩余步长数 * 预约步长
      return stepCount * step
    }
  },
  mounted() {
    this.initExps()
  },
  methods: {
    initExps() {
      this.curExp = null
      this.exps = []
      this.page = 1
      this.noMore = false
      this.loadExps()
    },
    loadExps() {
      if (this.noMore) {
        return
      }
      const that = this
      var eqId = this.$route.query.equipmentId
      var bookingId = this.$route.query.bookingId
      console.log("eqId",eqId)
      console.log("bookingId",bookingId)
      this.loading = true
      let data = new FormData()
      data.append('page', `${this.page}`)
      data.append('limit', '20')
      this.$http.post(`/api/experiment/list`, data).then(res => {
        // 只在第一页且curExp为空时查询当前实验（无论list是否有数据）
        if (!that.curExp && that.page === 1 && eqId) {
          this.queryexperimentByeqId(eqId, bookingId)
        }

        if (res.data && res.data.length > 0) {
          const exps = res.data
          that.exps = that.exps.concat(exps)
          that.loading = false
          that.page = that.page + 1
        } else {
          that.noMore = true
          that.loading = false
        }
      })
    },
    beginEnd(beginAt, endAt) {
      let beginYMD = this.$moment(beginAt).format('YYYY.MM.DD')
      let result = this.$moment(beginAt).format('YYYY.MM.DD HH:mm')
      if (endAt) {
        let endYMD = this.$moment(endAt).format('YYYY.MM.DD')
        if (endYMD == beginYMD) {
          result += (" - " + this.$moment(endAt).format('HH:mm'))
        } else {
          result += (" - " + this.$moment(endAt).format('YYYY.MM.DD HH:mm'))
        }
      } else {
        result += " - "
      }
      return result
    },
    displaySpent(spent) {
      let totalSeconds = Math.floor(spent / 1000)
      let hours = Math.floor(totalSeconds / 3600)
      let minutes = Math.floor((totalSeconds - hours * 3600) / 60)
      let seconds = totalSeconds - hours * 3600 - minutes * 60
      return this.fillZero(hours) + ':' + this.fillZero(minutes) + ':' + this.fillZero(seconds)
    },
    formatDate(date) {
      return this.$moment(date).format('YYYY.MM.DD HH:mm')
    },
    fillZero(num) {
      if (num < 10) {
        return '0' + num;
      } else {
        return num;
      }
    },
    viewScore(exp) {
      this.$router.push({
        path: '/exp-score',
        query: {
          id: exp.id,
          view: true
        }
      })
    },
    doScore(exp) {
      this.$router.push({
        path: '/exp-score',
        query: {
          id: exp.id
        }
      })
    },
    // 判断实验是否可以释放机时：当前时间早于预约结束时间
    canExpReleaseTime(exp) {
      if (!exp || !exp.booking || !exp.booking.endAt) {
        return false
      }
      const now = this.$moment().valueOf()
      const endAt = exp.booking.endAt
      return now < endAt
    },
    // 计算剩余时间和可释放时间
    calcReleaseInfo(exp) {
      if (!exp || !exp.booking || !exp.booking.endAt || !exp.booking.beginAt) {
        return { remainTime: 0, releaseTime: 0 }
      }
      const now = this.$moment().valueOf()
      const beginAt = exp.booking.beginAt
      const endAt = exp.booking.endAt
      let remainMs
      // 若当前时间早于预约开始时间，remainTime = endAt - beginAt
      // 若当前时间晚于等于预约开始时间，remainTime = endAt - currentTime
      if (now < beginAt) {
        remainMs = endAt - beginAt
      } else {
        remainMs = endAt - now
      }
      // 剩余时间（分钟）
      const remainTime = Math.max(0, Math.floor(remainMs / (1000 * 60)))
      // 预约步长，默认30分钟
      const step = exp.bookingStep || 30
      // 剩余步长数 = (remainTime/预约步长)向下取整
      const stepCount = Math.floor(remainTime / step)
      // 可释放时间 = 剩余步长数 * 预约步长
      const releaseTime = stepCount * step
      return { remainTime, releaseTime }
    },
    // 实验进行中的释放机时
    releaseTime(exp) {
      const that = this
      const canRelease = this.canExpReleaseTime(exp)
      let confirmMsg, successMsg

      if (canRelease) {
        const { remainTime, releaseTime } = this.calcReleaseInfo(exp)
        confirmMsg = `您当前实验的预约机时还剩${remainTime}分钟，预计可释放机时为${releaseTime}分钟。请确认是否释放未使用的预约机时？`
        successMsg = '释放机时成功'
      } else {
        confirmMsg = '确定要结束实验吗？'
        successMsg = '结束实验成功'
      }
      const finalAccounts = canRelease // 只有可释放时才传 true

      MessageBox.confirm(confirmMsg).then(() => {
        that.$http.post(`/api/experiment/end?id=${exp.id}&finalAccounts=${finalAccounts}&operationByUser=true`).then(res => {
          if (res.success) {
            Toast(successMsg)
            that.initExps()
          } else {
            Toast(res.msg || '操作失败')
          }
        }).catch(() => {
          Toast('操作失败，请稍后重试')
        })
      })
    },
    // 已结束实验的释放机时
    releaseTimeAfterEnd(exp) {
      const that = this
      const { remainTime, releaseTime } = this.calcReleaseInfo(exp)
      const confirmMsg = `您当前实验的预约机时还剩${remainTime}分钟，预计可释放机时为${releaseTime}分钟。实验结束后释放机时系统不调整费用，如有费用调整述求请联系管理员。请确认是否释放未使用的预约机时？`

      MessageBox.confirm(confirmMsg).then(() => {
        that.$http.post(`/api/experiment/end?id=${exp.id}&finalAccounts=true&operationByUser=true`).then(res => {
          if (res.success) {
            Toast('释放机时成功')
            that.initExps()
          } else {
            Toast(res.msg || '操作失败')
          }
        }).catch(() => {
          Toast('操作失败，请稍后重试')
        })
      })
    },
    doEnd(id){
      console.log("结束ID",id)
      const that = this
      this.$http.post(`/api/experiment/end?id=${id}&finalAccounts=${that.finalAccounts}&operationByUser=true`).then(res => {
        if(res.success){
          that.initExps()
        }
      })
    },
    doEndTwo(id) {
      console.log("结束ID", id)
      const that = this
      var eqId = this.$route.query.equipmentId
      const fullPath=encodeURIComponent(that.$route.fullPath)
      this.$http.get('/api/booking/regisBiz?equipmentId=' + eqId + "&bizOperator=close&bookingId="+this.$route.query.bookingId+"&fullPath="+fullPath).then(res => {
        if (res.success && res.data && res.data.scheme) {
          that.scheme = res.data.scheme


          const ua = window.navigator.userAgent.toLowerCase();
          if (ua.match(/micromessenger/i)) {
            // 微信环境下
            wx.miniProgram.getEnv((res) => {
              if (res.miniprogram) {
                console.log("小程序环境下逻辑")
                let bizCode=that.scheme.substring(that.scheme.indexOf("id%3D")+5)
                console.log("bizCode",bizCode)
                wx.miniProgram.navigateTo({
                  url: '/pages/index/index?id='+bizCode
                });

              } else {
                console.log("非小程序环境下逻辑")
                window.location.href= that.scheme
              }
            });
          } else {
            console.log("非微信环境下")
            window.location.href= that.scheme
          }

          //window.location.href = that.scheme
          let bizId=res.data.bizId

          this.$http.post(`/api/booking/getBizStatus?experimentId=${id}&finalAccounts=${that.finalAccounts}&operationByUser=true&bizId=`+bizId).then(() => {})

          that.popupVisible = false
          let count=0;
          let timer=setInterval(()=>{
            that.getBizLastStatus(bizId,id);
            count++;
            this.loadFlag=true
            if (that.endFlag || count>10){
              clearInterval(timer)
              this.loadFlag=false
              if (count>10){
                setTimeout(()=>{
                  Toast('抱歉，蓝牙连接失败，请检查微信位置、微信附近的设备和蓝牙是否开启。确认开启后，请重新扫码或尝试其他设备');
                },1000)
              }
            }
          }, 3000);

        } else {
          Toast('数据获取失败');
        }
      })
    },
    getBizLastStatus(bizId,id){
      console.log("结束ID", id)
      if (!this.endFlag){
        this.$http.get('/api/booking/getBizLastStatus?bizId='+bizId+'&bizOperator=close').then(response =>{
          if(response.success && response.data.machineLastState=='0'){
            this.endFlag=true
            this.$router.push("/")
          }
        })
      }

    },
    endExp() {
      const that = this
      that.popupVisible = true
    },
    cancelEnd(){
      this.popupVisible = false
    },
    queryexperimentByeqId(eqId,bookingId){
      const that = this
      if (intervalId) {
        window.clearInterval(intervalId)
      }
      // equipmentId 是必须的，bookingId 是可选的
      if (!eqId){
        return
      }
      // 构建请求URL，bookingId可选
      let url = `/api/experiment/infoByEquipmentId?equipmentId=${eqId}`
      if (bookingId) {
        url += `&bookingId=${bookingId}`
      }
      this.$http.post(url).then(res=>{
        if(res.data && res.data.length > 0){
          let latestExp = res.data[0]
          if (latestExp.endAt <= 0) {
            that.curExp = latestExp
            that.curExp.spent = that.displaySpent(that.$moment().valueOf() - that.curExp.beginAt)
            intervalId = window.setInterval(function () {
              that.curExp.spent = that.displaySpent(that.$moment().valueOf() - that.curExp.beginAt)
            }, 1000)
          }
        }
      }).catch(err => {
        console.error("查询实验信息失败:", err)
      })
    },
    getEquipInfo(eqId){
      this.$http.get('/api/equipment/info?equipmentId='+eqId+'&bizOperator=close').then(res =>{
        if (res.equipment.blueToothType){
          this.blueToothTypeShow=true
        }
      })

    },
    goHome() {
      this.$router.push("/")
    }
  }

}
</script>
